import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'Accueil', to: '/' },
  { label: 'Peinture', to: '/peinture' },
  { label: 'Digital', to: '/digital' },
  { label: "L'artiste", to: '/#artiste' },
  { label: 'Contact', to: '/#contact' },
];

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activePath, setActivePath] = useState("/");
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    setActivePath(`${location.pathname}${location.hash}`);
    setIsMenuOpen(false);
  }, [location.pathname, location.hash]);

  return (
    <nav className='site-nav'>
      <button
        onClick={toggleMenu}
        type="button"
        className="site-nav__toggle focus-ring"
        aria-controls="site-navigation"
        aria-expanded={isMenuOpen}
      >
        <span className="sr-only">Ouvrir le menu principal</span>
        <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h15M1 7h15M1 13h15" />
        </svg>
      </button>
      <div id="site-navigation" className={`site-nav__panel ${isMenuOpen ? 'site-nav__panel--open' : ''}`}>
        <ul className='site-nav__list'>
          {navItems.map((item) => (
            <li key={item.to}>
              <Link
                className={`site-nav__link focus-ring ${activePath === item.to || (item.to === '/' && activePath === '/') ? 'site-nav__link--active' : ''}`}
                to={item.to}
              >
                
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};
